import { lazy } from 'react';

export const BimCalculationLocalEstimate = lazy(() =>
    import('./BimCalculationLocalEstimate').then((module) => ({ default: module.BimCalculationLocalEstimate })),
);
